"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProfileData = void 0;
const axios_1 = __importDefault(require("axios"));
const auth_1 = require("../api/auth");
const user_jpg_1 = __importDefault(require("../resources/img/user.jpg"));
async function getProfileData() {
    const response = await axios_1.default.get(`${window.process.env['API_SERVER_URL']}/users`);
    const usersDataArray = response.data;
    const userData = usersDataArray.filter((userData) => {
        return userData.username === auth_1.username;
    })[0];
    if (!userData) {
        throw new Error('User not found in server list');
    }
    const fullName = userData.firstName + ' ' + userData.lastName.charAt(0) + '.';
    return {
        avatarUrl: user_jpg_1.default,
        fullName: fullName,
    };
}
exports.getProfileData = getProfileData;
